import React from "react";

const Reporttable = ({ list }) => {

  return (
    <div className="container-fluid">
      <table className="table responsive table-hover">
        <thead >
          <tr>
            <th scope="col">ลำดับ</th>
            <th scope="col">ไม้ท่อนรับเข้า</th>
            <th scope="col">ไม้ท่อนผลิต</th>
            <th scope="col">Direct เข้าผลิต</th>
            <th scope="col">Stock เข้าผลิต</th>
            <th scope="col">ผลผลิต ตัน/วัน</th>
            <th scope="col">ไม้สับส่งออก</th>
            <th scope="col">เปลือกส่งอก</th>
            <th scope="col">Stock ไม้ท่อน</th>
            <th scope="col">Stock ไม้สับ</th>
            <th scope="col">Stock เปลือก</th>
            <th scope="col">Stock Undersize</th>
          </tr>
        </thead>

        <tbody>
          {list &&
            list.length > 1 &&
            list.map((item, index) => (
              <tr key={index}>
                <th scope="row">
                  <span className="badge rounded-pill bg-secondary me-1">
                   
                    {index + 1}
                  </span>
                  <span className="">{item.BranchName}</span>
                </th>
                <td>


                  {item.logrecive === 0 ? null:

                    <span
                    className="badge bg-success me-1"
                    style={{ fontSize: "14px" }}
                  >
                    {item.logrecive}
                  </span> }


                  {/* ไม้ท่อนรับเข้า */}
                </td>
                <td>
                  {item.logtoproduce ===0 ?null: <span
                    className="badge bg-success me-1"
                    style={{ fontSize: "14px" }}
                  >
                    {item.logtoproduce}
                  </span>}
                  {/* ไม้ท่อนผลิต */}
                </td>
                <td>

                { item.directproduce ===0 ?null: <span
                    className="badge bg-success me-1"
                    style={{ fontSize: "14px" }}
                  >
                    {item.directproduce}
                  </span>}
                  {/* Direct เข้าผลิต */}
                </td>
                <td>
                 {item.stockproduce===0 ?null:<span
                    className="badge bg-success me-1"
                    style={{ fontSize: "14px" }}
                  >
                    {item.stockproduce}
                  </span>}
                  {/* Stock เข้าผลิต  */}
                </td>
                <td>
                  {item.productperday===0 ?null:
                  <span
                    className="badge bg-success me-1"
                    style={{ fontSize: "14px" }}
                  >
                    {item.productperday}
                  </span>}
                  {/*ผลผลิต ตัน/วัน */}
                </td>
                <td>
                 { item.chipout===0 ?null:<span
                    className="badge bg-success me-1"
                    style={{ fontSize: "14px" }}
                  >
                    {item.chipout}
                  </span>}
                  {/*ไม้สับส่งออก */}
                </td>
                <td>
                  {item.barkout===0 ?null:
                  <span
                    className="badge bg-success me-1"
                    style={{ fontSize: "14px" }}
                  >
                    {item.barkout}
                  </span>}
                  {/*เปลือกส่งออก */}
                </td>
                <td>
                  {item.logstock===0 ?null:<span
                    className="badge bg-success me-1"
                    style={{ fontSize: "14px" }}
                  >
                    {item.logstock}
                  </span>}
                  {/*Stock ไม้ท่อน */}
                </td>
                <td>
                  {item.chipstock===0 ?null:<span
                    className="badge bg-success me-1"
                    style={{ fontSize: "14px" }}
                  >
                    {item.chipstock}
                  </span>}
                  {/*Stock ไม้สับ */}
                </td>
                <td>
                 {item.barkstock===0 ?null:<span
                    className="badge bg-success me-1 "
                    style={{ fontSize: "14px" }}
                  >
                    {item.barkstock}
                  </span>}
                  {/*Stock เปลือก */}
                </td>
                <td>
                  {item.undersizestock===0 ?null:<span
                    className="badge bg-success me-1"
                    style={{ fontSize: "14px" }}
                  >
                    {item.undersizestock}
                  </span>}
                  {/*Stock Undersize */}
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default Reporttable;
